import { useGroupNamesQuery } from '@/hooks/group/queries/use-group-names.query';
import { useMembershipsByUserQuery } from '@/hooks/membership/queries/use-memberships-by-user.query';
import { MembershipGroup } from '@/types/membership-group/membership-group';

type TReturn =
  | {
      data: undefined;
      isPending: false;
      isError: true;
    }
  | {
      data: undefined;
      isPending: true;
      isError: false;
    }
  | {
      data: MembershipGroup[];
      isPending: false;
      isError: false;
    };

export function useMembershipGroupsQuery(): TReturn {
  const membershipsQuery = useMembershipsByUserQuery();
  const params = membershipsQuery.data?.length ? { id: membershipsQuery.data.map((m) => m.groupId) } : undefined;
  const groupsQuery = useGroupNamesQuery(params!);

  if (membershipsQuery.isPending || groupsQuery.isPending) {
    return {
      data: undefined,
      isPending: true,
      isError: false,
    };
  }

  if (membershipsQuery.isError || groupsQuery.isError) {
    return {
      data: undefined,
      isPending: false,
      isError: true,
    };
  }

  const combined: MembershipGroup[] = membershipsQuery.data.map((membership) => {
    const group = groupsQuery.data.find((group) => group.id === membership.groupId)!;
    return {
      groupId: membership.groupId,
      membershipId: membership.id,
      membershipRoles: membership.roles,
      name: group.name,
    };
  });

  return {
    isPending: false,
    isError: false,
    data: combined,
  };
}
